import { forwardRef } from 'react'
import { Check } from '../../icons'
import { cn } from '../../lib/cn'
import { Button, type ButtonProps } from '../button/button'

export interface ChoiceChipProps extends Omit<ButtonProps, 'variant' | 'size' | 'aria-pressed'> {
  selected: boolean
}

/** A selectable label shared by single- and multiple-choice fields. */
export const ChoiceChip = forwardRef<HTMLButtonElement, ChoiceChipProps>(
  ({ selected, children, className, ...props }, ref) => (
    <Button
      {...props}
      ref={ref}
      type={props.type ?? 'button'}
      variant={selected ? 'active' : 'outline'}
      aria-pressed={selected}
      className={cn(
        'h-auto min-h-[var(--control-h)] max-w-full whitespace-normal text-left',
        className
      )}
    >
      <span
        aria-hidden
        className='inline-flex size-[var(--s-7)] shrink-0 items-center justify-center'
      >
        {selected && <Check className='size-full' />}
      </span>
      <span className='min-w-0 break-words'>{children}</span>
    </Button>
  )
)
ChoiceChip.displayName = 'ChoiceChip'
